import './hero.css';
import React from 'react';
import img21 from '../img/hero.jpg';

function Hero() {
  const createWhatsAppLink = () => {
    const message = `السلام عليكم، أريد الحصول على إستشارة مجانية`;
    return `https://wa.me/966568300288?text=${encodeURIComponent(message)}`;
  };
  
  return (
    <div className='hero' id='heroid'>
      <div
        id="intro-example"
        className="text-center bg-image"
        style={{ backgroundImage: `url(${img21})` }}
      >
        <div className="mask" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}>
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="text-white">
              <h1 className="mb-3">ابدأ رحلتك مع تصميم وبرمجة الموقع الإلكتروني المثالي!</h1>
              <h5 className="mb-0">
                اجذب جمهورك وحقق نتائج أفضل مع أدواتنا الفعالة والمتقدمة لتصميم وبرمجة المواقع الإلكترونية.
              </h5>
              <h5 className="mb-4">
                احصل على حلول مخصصة تلبي احتياجاتك وتفوق توقعاتك.
              </h5>
              <a
                data-mdb-ripple-init
                className="btn btn-outline-light btn-lg m-2"
                href={createWhatsAppLink()}
                role="button"
                rel="nofollow"
                target="_blank"
              >
                إطلب إستشارتك المجانية
              </a>
              <a
                data-mdb-ripple-init
                className="btn btn-outline-light btn-lg m-2"
                href="tel:0568300288"
                role="button"
              >
                تواصل معنا
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
